import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
} from "@angular/core";
import { GooglePlaceDirective } from "ngx-google-places-autocomplete";
import { Address } from 'ngx-google-places-autocomplete/objects/address';
@Component({
  selector: "app-geo-location",
  templateUrl: "./geo-location.component.html",
  styleUrls: ["./geo-location.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class GeoLocationComponent implements OnInit {
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  @Output() geoData: EventEmitter<any> = new EventEmitter();
  options = {
    componentRestrictions: { country: "IN" },
  };
  constructor() {}

  ngOnInit() {}
  autoCompleteCallback(geolocation: Address) {
    const location = {
      response : true,
      data: {
        geometry: {
          location: {
            geolocation,
            lat: String(geolocation.geometry.location.lat()),
            lng: String(geolocation.geometry.location.lng())
            }
         }
       }
    }
    this.geoData.emit(location);
  }
}
